import styled from 'styled-components';
import { MenuIcon, device } from '../../mediaQuery';

export const SidebarContainer = styled.div`
	background-color: var(--colorBlack);
	width: 250px;
	height: 100vh;
	display: block;
	position: fixed;
	z-index: 500;
	left: ${({ show }) => (show ? 0 : '-1000px')};
	transition: all .3s ease-in-out;

	@media ${device.tablet} {
		display: none;
	}
`;

export const SidebarUl = styled.ul`
	width: inherit;
	height: 500px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	font-size: var(--fontS);
	font-weight: var(--fontBold);
`;

export const SidebarLi = styled.li`
	padding-left: 25px;
	color: var(--colorWhite);
	list-style: none;
	line-height: 50px;
	letter-spacing: 1px;
	cursor: pointer;
	width: 100%;

	:hover {
		color: var(--colorRed);
	}
`;

export const Icon = styled(MenuIcon)`
color: var(--colorWhite);
`;

export const Backdrop = styled.div`
	height: 100vh;
	position: fixed;
	background-color: rgba(0, 0, 0, 0.8);
	width: 100%;
	display: ${({ show }) => (show ? 'block' : 'none')};
	z-index: 100;

	@media ${device.tablet} {
		display: none;
	}
`;
